import axios from 'axios'
import config from './../../../config'

export default {
  login (params) {
    return axios.post(`${config.api_url}/v4/auth/sign-in/mpo`, params)
  },
  logout () {
    // Mock the promise, so we can easily replace this
    // with call to api when logout endpoint will be ready
    return new Promise(
      (resolve) => setTimeout(() => resolve(), 0)
    )
  }
}
